import { render, staticRenderFns } from "./CursosModulares.vue?vue&type=template&id=12ab1882&"
import script from "./CursosModulares.vue?vue&type=script&lang=js&"
export * from "./CursosModulares.vue?vue&type=script&lang=js&"
import style0 from "./CursosModulares.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports